const es = {
  // Navbar
  nav_services: 'Servicios',
  nav_portfolio: 'Portfolio',
  nav_about: 'Sobre nosotros',
  nav_contact: 'Contacto',

  // Hero
  hero_label: 'Consultoría · Revenue Growth · Incubación',
  hero_headline_1: 'Estrategia, ejecución y',
  hero_headline_2: 'crecimiento real',
  hero_sub: 'Consultoría de revenue, acompañamiento operativo e incubación de negocios. Para empresas que quieren escalar con rigor.',
  hero_cta_primary: 'Hablemos',
  hero_cta_secondary: 'Ver portfolio',

  // Services
  services_label: 'Qué hacemos',
  services_title: 'Tres pilares, un sistema',
  services_desc: 'Cada pilar se alimenta de los demás. La consultoría genera conocimiento, el conocimiento identifica oportunidades, las oportunidades se convierten en negocios.',
  s1_title: 'Consultoría',
  s1_desc: 'Diagnóstico y estrategia de crecimiento. Trabajamos con equipos de dirección para identificar palancas de revenue, optimizar el go-to-market y diseñar la máquina comercial.',
  s2_title: 'Revenue Growth',
  s2_desc: 'Formación y acompañamiento operativo en revenue operations. No dejamos un informe — nos quedamos hasta que los números se mueven.',
  s3_title: 'Incubación',
  s3_desc: 'Identificamos oportunidades, co-creamos negocios y participamos en su desarrollo. Con piel en el juego, desde la idea hasta la tracción.',

  // Portfolio
  portfolio_label: 'Portfolio',
  portfolio_title: 'Con quién trabajamos',
  portfolio_sub: 'Empresas y proyectos que acompañamos',
  portfolio_cta: 'Ver proyecto',
  portfolio_note: 'Portfolio en construcción. Nuevos proyectos próximamente.',
  tob_sector: 'Industria 4.0 · Residuos & Energía',
  tob_desc: 'Transforman residuos industriales en activos de valor mediante tecnología de datos y automatización. Optimización de procesos, valorización de residuos y centros de datos integrados en planta.',
  tob_tag: 'Operaciones & Tecnología',
  cb_sector: 'Fintech · Bitcoin & Custodia',
  cb_desc: 'Servicio de custodia colaborativa y soberanía para Bitcoin. Solución multifirma que permite mantener el control de los fondos sin depender de bancos ni custodios centralizados.',
  cb_tag: 'Estrategia & Finanzas',

  // About
  about_label: 'Sobre nosotros',
  about_title: 'Quién está detrás',
  about_role: 'Fundador',
  about_bio1: 'Trayectoria en consultoría tecnológica y en creación de modelos de negocio. Foco en crecimiento de revenue, estrategia comercial y construcción de negocios desde cero. Alice & Bob Capital nace de la convicción de que la mejor consultoría es la que tiene skin in the game.',
  about_bio2: 'No somos un fondo de inversión. No somos una consultora tradicional. Somos un vehículo que acompaña a empresas en crecimiento con estrategia, operaciones y, cuando tiene sentido, participación directa.',

  // Contact
  contact_label: 'Contacto',
  contact_title: 'Hablemos',
  contact_sub: 'Si quieres explorar cómo podemos trabajar juntos, escríbenos.',
  contact_name: 'Nombre',
  contact_name_ph: 'Tu nombre',
  contact_email: 'Email',
  contact_email_ph: 'tu@email.com',
  contact_message: 'Mensaje',
  contact_message_ph: 'Cuéntanos en qué estás trabajando...',
  contact_send: 'Enviar',
  contact_sending: 'Enviando...',
  contact_success: 'Mensaje enviado. Te contactaremos pronto.',
  contact_error: 'Algo salió mal. Inténtalo de nuevo.',

  // Footer
  footer_copy: '© 2026 Alice & Bob Capital',
};

export default es;
